"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_1 = require("react-router");
var formik_1 = require("formik");
var Terms_1 = require("./AddDebtWizardPages/Terms");
var DebtorSearch_1 = require("./AddDebtWizardPages/DebtorSearch");
var Jurisdiction_1 = require("./AddDebtWizardPages/Jurisdiction");
var DebtType_1 = require("./AddDebtWizardPages/DebtType");
var Debtor_1 = require("./AddDebtWizardPages/Debtor");
var DebtDetails_1 = require("./AddDebtWizardPages/DebtDetails");
var InvoiceDetails_1 = require("./AddDebtWizardPages/InvoiceDetails");
var InvoiceUpload_1 = require("./AddDebtWizardPages/InvoiceUpload");
var Confirmation_1 = require("./AddDebtWizardPages/Confirmation");
var Cookie = require("js-cookie");
var getState_1 = require("../../../../utils/getState");
var AddDebtWizardRouter = function (props) {
    var _a = __read(React.useState({ id: null }), 2), selectedDebtor = _a[0], setSelectedDebtor = _a[1];
    var _b = __read(React.useState(0), 2), BOEInterestRate = _b[0], setBOEInterestRate = _b[1];
    var getBOEInterestRate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var rate;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    rate = null;
                    return [4 /*yield*/, fetch("".concat((0, getState_1.default)().api.endpoint, "/world_properties/read/bank_of_england_base_rate"), {
                            method: 'GET',
                            headers: {
                                Authorization: Cookie.get('sessionId'),
                            },
                        })
                            .then(function (res) { return res.json(); })
                            .then(function (response) {
                            rate = parseFloat(response.value.replace('%', ''));
                            setBOEInterestRate(rate);
                        })
                            .catch(function (error) {
                            console.log(error);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, rate];
            }
        });
    }); };
    React.useEffect(function () {
        getBOEInterestRate();
    }, []);
    return (React.createElement(formik_1.Form, { className: "flex-column add-debt-wizard-form" },
        React.createElement(react_router_1.Routes, null,
            React.createElement(react_router_1.Route, { path: "/page1", element: React.createElement(Terms_1.default, { setTCModal: props.setTCModal }) }),
            React.createElement(react_router_1.Route, { path: "/page2", element: React.createElement(DebtorSearch_1.default, { debtor: selectedDebtor, searchAndPopulateDebtors: props.searchAndPopulateDebtors, debtors: props.debtors, setDebtor: props.setDebtor, setSelectedDebtor: setSelectedDebtor, values: props.values, setFieldValue: props.setFieldValue, search_text: props.search_text, BOEInterestRate: BOEInterestRate }) }),
            React.createElement(react_router_1.Route, { path: "/page3", element: React.createElement(DebtType_1.default, { values: props.values, setFieldValue: props.setFieldValue, setFieldTouched: props.setFieldTouched, errors: props.errors, validator: props.validator, BOEInterestRate: BOEInterestRate }) }),
            React.createElement(react_router_1.Route, { path: "/page4", element: React.createElement(Debtor_1.default, { values: props.values, validator: props.validator, setFieldValue: props.setFieldValue, setFieldTouched: props.setFieldTouched, errors: props.errors }) }),
            React.createElement(react_router_1.Route, { path: "/page5", element: React.createElement(Jurisdiction_1.default, { values: props.values, setFieldValue: props.setFieldValue, validator: props.validator }) }),
            React.createElement(react_router_1.Route, { path: "/page6", element: React.createElement(DebtDetails_1.default, { values: props.values, validator: props.validator, setFieldValue: props.setFieldValue, setFieldTouched: props.setFieldTouched, errors: props.errors, BOEInterestRate: BOEInterestRate }) }),
            React.createElement(react_router_1.Route, { path: "/page7", element: React.createElement(InvoiceDetails_1.default, { values: props.values, validator: props.validator, setFieldValue: props.setFieldValue, setFieldTouched: props.setFieldTouched, errors: props.errors }) }),
            React.createElement(react_router_1.Route, { path: "/page8", element: React.createElement(InvoiceUpload_1.default, { values: props.values, validator: props.validator, setFieldValue: props.setFieldValue, setFileUpload: props.setFileUpload }) }),
            React.createElement(react_router_1.Route, { path: "/page9", element: React.createElement(Confirmation_1.default, { values: props.values, validator: props.validator, setFieldValue: props.setFieldValue, setFieldTouched: props.setFieldTouched, setFileUpload: props.setFileUpload, handleSubmit: props.handleSubmit, errors: props.errors, disabled: props.disabled, BOEInterestRate: BOEInterestRate }) }),
            React.createElement(react_router_1.Route, { path: "*", element: React.createElement(react_router_1.Navigate, { replace: true, to: '/dashboard/debtwizard/page1' }) }))));
};
exports.default = AddDebtWizardRouter;
